import IcArrowDown from './IcArrowDown'

export default IcArrowDown
